import React from 'react'
import PropTypes from 'prop-types'

class Plus extends React.Component {
  render() {
    return (
      <svg width="16px" height="16px" viewBox="0 0 12 12" version="1.1">
        <g id="Plus" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <path
            d="M7,6.95740603 L7,10.4148121 L5,10.4148121 L5,6.95740603 L1.54259397,6.95740603 L1.54259397,4.95740603 L5,4.95740603 L5,1.5 L7,1.5 L7,4.95740603 L10.457406,4.95740603 L10.457406,6.95740603 L7,6.95740603 Z"
            id="Combined-Shape"
            fill={this.props.backgroundColor}
          />
        </g>
      </svg>
    )
  }
}

Plus.propTypes = {
  backgroundColor: PropTypes.string,
}

export default Plus
